function filterProp() {
  jQuery(function ($) {
    $(document).on("change", "#filter", function () {
      var filter = $(this);
      $.ajax({
        url: filter.attr("action"),
        data: filter.serialize(),
        type: filter.attr("method"),
        dataType: "json",
        beforeSend: function (xhr) {},
        success: function (data) {
          $("#response").html(data["inputs"] + data["cards"]);
          $("#response-map").html(data["map"]);
          var curValt = parseInt($("#offset-cur").val());
          var loadmoret = $("#loadmore");
          var howmuchFiltred = $("#how-much-filtred").val();
          $("#howmuch").val(howmuchFiltred);
          if (curValt >= howmuchFiltred) {
            loadmoret.css({ display: "none" });
          } else {
            loadmoret.css({ display: "block" });
          }
          lazyLoadInstance.update();
          acfMap();
          if (window.innerWidth > 1439) {
            stickElem("#response-map", ".property-arch__left", 0);
          }
        },
      });
      return false;
    });
    $("#loadmore").click(function () {
      var filters = $("#filter");
      var loadmore = $(this);
      var getElementCur = $("#response").find("#offset-cur");
      var curVal = parseInt(getElementCur.val());
      var howmuchFiltredt = $("#how-much-filtred").val();
      $("#filter")
        .find("#offset-response")
        .val(curVal + 10);
      $.ajax({
        url: filters.attr("action"),
        data: filters.serialize(),
        type: filters.attr("method"),
        dataType: "json",
        beforeSend: function (xhr) {},
        success: function (data) {
          $("#response").html(data["inputs"] + data["cards"]);
          if (curVal + 10 >= howmuchFiltredt) {
            loadmore.css({ display: "none" });
          }
          lazyLoadInstance.update();
          if (window.innerWidth > 1439) {
            stickElem("#response-map", ".property-arch__left", 0);
          }
        },
      });
      return false;
    });
    $("#filter").find("#offset-response").val(10);
  });
}
module.exports = filterProp;
